import { Props_SnippetRepeatableImageContent } from './RepeatableImageContent.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'


const classAssignment = (prop: string | undefined | boolean, positiveClassName: string, negativeClassName = '') => {
    if (prop) {
        if (typeof prop === 'string') {
            return `${positiveClassName}--${prop}`
        }
        if (typeof prop === 'boolean') {
            return positiveClassName
        }
    }
    return negativeClassName
}


type RepeatableItem = Props_SnippetRepeatableImageContent['repeatable_item'][number]

const RepeatableImageContentItem = ({ item }: { item: RepeatableItem }) => {
    const {
        layout, backgroundColor, fontColor,
        headingContent, headingVisibility, headingColor,
        content, imageSrc, imageAlt,
        linkAlignment, linkText, linkHref, linkStyle, linkTarget, imageFit
    } = item

    const classHeadingVisibility = classAssignment(headingVisibility?.value, 'snippet-repeatable-image-content__heading--visible', 'snippet-repeatable-image-content__heading--hidden')
    const classHeadingColor = classAssignment(headingColor?.value, 'snippet-repeatable-image-content__heading--color')
    const classSnippetLayout = classAssignment(layout?.value, 'snippet-repeatable-image-content__item')
    const classLinkAlignment = classAssignment(linkAlignment?.value, 'snippet-repeatable-image-content__button-container')
    const backgroundColorClass = classAssignment(backgroundColor?.value, 'snippet-repeatable-image-content__item--bg')
    const fontColorClass = classAssignment(fontColor?.value, 'snippet-repeatable-image-content__item--font')
    const imageFitClass = classAssignment(imageFit?.value, 'snippet-repeatable-image-content__image')
    const modifierClasses = `${classSnippetLayout} ${backgroundColorClass} ${fontColorClass}`

    return (
        <div className={`snippet-repeatable-image-content__item ${modifierClasses}`}>
            <div className="snippet-repeatable-image-content__item-row">
                <div className="snippet-repeatable-image-content__item-image">
                    <img
                        loading="lazy"
                        src={imageSrc.value}
                        className={`snippet-repeatable-image-content__image ${imageFitClass}`}
                        height="360"
                        width="600"
                        alt={imageAlt?.value || ''}
                    />
                </div>
                <div className="snippet-repeatable-image-content__item-content">
                    <div className={`snippet-repeatable-image-content__heading ${classHeadingVisibility} ${classHeadingColor}`}>
                        {CompileMarkdown(headingContent.value!)}
                    </div>
                    {content?.value && (
                        <div className="snippet-repeatable-image-content__content">
                            {CompileMarkdown(content.value)}
                        </div>
                    )}

                    <div className={`snippet-repeatable-image-content__button-container ${classLinkAlignment}`}>
                        <div className="snippet-repeatable-image-content__link">
                            <SnippetLink
                                linkStyles={linkStyle?.value}
                                className="snippet-repeatable-image-content__link"
                                url={linkHref?.value}
                                openInNewTab={linkTarget?.value}
                            >
                                {linkText?.value}
                            </SnippetLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const SnippetRepeatableImageContent = (props: Props_SnippetRepeatableImageContent) => {
    const { container, repeatable_item } = props

    const classHeadingColor = classAssignment(container.headingColor?.value, 'snippet-repeatable-image-content__container-heading--color')

    return (
        <section className="snippet-repeatable-image-content">
            <div className="snippet-repeatable-image-content__container">
                {container.showHeading?.value && container.heading?.value && (
                    <div className={`snippet-repeatable-image-content__container-heading ${classHeadingColor}`}>
                        {CompileMarkdown(container.heading.value)}
                    </div>
                )}

                {repeatable_item.map((item, itemIndex) => (
                    <RepeatableImageContentItem key={itemIndex} item={item} />
                ))}
            </div>
        </section>
    )
}

export default SnippetRepeatableImageContent